<template>
  <div class="c-table__cell-value" :class="{ 'cell-rank_disabled': !canEdit }" @click="canEdit && (isShowContainer = true)">
    <span v-if="calculateType!=='byDate'">{{rankLocalValueLabel}}</span>
    <Select2
      v-if="calculateType=='byDate'"
      v-model="rankLocalValue"
      class="cell-rank-select"
      :options="rankLocalItems"
      :disabled="!canEdit"
      :settings="{
        minimumResultsForSearch: Infinity,
        dropdownCssClass: 'needsclick',
        selectionCssClass: 'needsclick',
      }"
      @select="selectRank($event)"
    />
  </div>
</template>

<script>
import Select2 from "v-select2-component";

export default {
  name: "production-cell-rank",
  components: {
    Select2,
  },
  props: ["record", "calculationData", "calculateType", "canEdit"],
  data() {
    return {
      isShowContainer: false,
      rankLocalItems: [],
      rankLocalValue: null,
      rankLocalValueLabel: null,
    };
  },
  mounted() {
    const productionPost = this.calculationData.settings.production[this.record.codeGroup];
    if (!productionPost || !productionPost.categories) {
      return;
    }
    const ranks = productionPost.categories;
    Object.values(ranks).forEach((value) => {
      this.rankLocalItems.push({ id: value.id, text: value.number, s: value.s });
    });
    const findIndexRank = this.rankLocalItems.findIndex(
      (rank) => this.record.rank && this.record.rank.value && rank.id.toString() === this.record.rank.value.toString(),
    );
    if (findIndexRank !== -1) {
      this.rankLocalValue = this.rankLocalItems[findIndexRank].id;
      this.rankLocalValueLabel = this.rankLocalItems[findIndexRank].text;
    }
  },
  methods: {
    selectRank({ s }) {
      if (!this.canEdit) {
        return;
      }
      this.$emit("updateRank", {id:this.rankLocalValue, record:this.record});
    },
    timeToDecimal(t) {
      t = t.split(":");
      return parseFloat(parseInt(t[0], 10) + parseInt(t[1], 10) / 60);
    },
  },
};
</script>

<style lang="scss" scoped>
.cell-rank_disabled {
  cursor: default;
}

.cell-rank {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  &:active,
  &:hover {
    outline-style: solid;
    outline-width: 1px !important;
    outline-color: #0066ff !important;
    box-shadow: 0 0 10px rgba(0, 102, 255, 0.4);
  }

  &-select {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    & ::v-deep .select2-selection__rendered {
      font-size: 13px !important;
      line-height: 60px !important;
    }

    & ::v-deep .select2-container .select2-selection--single {
      height: 60px !important;
      border: none;
      background: inherit !important;
    }

    & ::v-deep b[role="presentation"] {
      display: none !important;
    }

    & ::v-deep .select2-selection__arrow {
      background-image: url("data:image/svg+xml,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.30964 6.70905C4.92189 6.32111 4.92189 5.69215 5.30964 5.30421L10.305 0.306472C10.6928 -0.0814626 11.3214 -0.081462 11.7092 0.306473C12.0969 0.694408 12.0969 1.32337 11.7092 1.71131L6.71381 6.70905C6.32606 7.09698 5.69739 7.09698 5.30964 6.70905Z' fill='%238E9CBB'/%3E%3Cpath d='M6.70587 6.70905C7.09363 6.32111 7.09363 5.69215 6.70587 5.30421L1.69498 0.290951C1.30723 -0.096984 0.678565 -0.0969834 0.290814 0.290951C-0.0969378 0.678886 -0.0969378 1.30785 0.290814 1.69579L5.3017 6.70905C5.68946 7.09698 6.31812 7.09698 6.70587 6.70905Z' fill='%238E9CBB'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: center center;
    }

    & ::v-deep .select2-selection__rendered {
      padding-left: 11px;
    }

    & ::v-deep .select2-selection__arrow {
      top: 50% !important;
      right: 6px;
      transform: translate(0, -50%) !important;
    }
  }
}
</style>
<style lang="scss">
@import "~@/assets/styles/vars";
.select2-container {
  min-width: 70px !important;
}
.select2-dropdown {
  border: none;
  padding: 10px;
  background-color: #ffffff;
  margin-top: 7px !important;
  width: 85px !important;
  box-shadow: 0 4px 16px rgba(0, 15, 38, 0.25);
  border-radius: 6px !important;
}
.select2-results__options {
  &::-webkit-scrollbar {
    width: 4px;
    height: 100%;
  }

  &::-webkit-scrollbar-thumb {
    background: $color-secondary;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: $color-border-alt;
    border-radius: 4px;
  }
}
.select2-results__option {
  margin-right: 10px;
  padding: 1px 8px;
  font-size: 15px;
  line-height: 190%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 15px;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.select2-results__option--highlighted {
  background-color: #e1edff !important;
  color: #000 !important;
}
</style>
